module.exports = __webpack_public_path__ + "static/img/gw_empty.df11a36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/gw_empty.png
// module id = 4QNv
// module chunks = 1